import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  GetParamsForDocCreationResponse,
  ParamsForDocCreationDTO,
} from "../../models/documentParams.model";
import { getParamsForDocCreation } from "../thunks/documentParamsThunks";

interface DocumentParamsState {
  params: ParamsForDocCreationDTO | null;
  loading: boolean;
  error: string | null;
}

const initialState: DocumentParamsState = {
  params: null,
  loading: false,
  error: null,
};

const documentParamsSlice = createSlice({
  name: "documentParams",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getParamsForDocCreation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getParamsForDocCreation.fulfilled,
        (state, action: PayloadAction<GetParamsForDocCreationResponse>) => {
          state.loading = false;
          state.params = action.payload.paramsForDocCreation;
        },
      )
      .addCase(getParamsForDocCreation.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "שגיאה בטעינת נתוני מסמך";
      });
  },
});

export default documentParamsSlice.reducer;
